import { forwardRef, type Ref, type SVGProps } from "react";
const IconPhoneFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26.41 2.81 20.68 2a1.87 1.87 0 0 0-1.94 1.2l-2 6.2a1.78 1.78 0 0 0 .72 2l3.27 2.1c-.51 2.3-.82 4.7-5 7.6l-2.86-2.5a1.74 1.74 0 0 0-2.05-.3l-5.84 3.1a1.74 1.74 0 0 0-.81 2.1l1.84 5.4a1.74 1.74 0 0 0 1.84 1.2c13.93-1.4 21.4-11.9 20.07-25.8a1.53 1.53 0 0 0-1.51-1.49"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPhoneFilledSVG);
ForwardRef.displayName = "IconPhoneFilled";
export { ForwardRef as IconPhoneFilled };
